import { getPageConfig } from '@/lib/aggregation';
import type { PrismicObject } from '@/types/prismic/common';
import type { LogOutPopData } from '@/types/aggregation/common';

export const getLogoutPopupData = async ({
    currentRoute
}: {
    currentRoute: string;
}): Promise<PrismicObject<'logout_popup', LogOutPopData> | undefined> => {
    const pageConfig = await getPageConfig(currentRoute);

    return pageConfig?.pageConfig?.product?.data?.logout_popup;
};
